import { render, staticRenderFns } from "./ReclamationAdd.vue?vue&type=template&id=3f695de2"
import script from "./ReclamationAdd.vue?vue&type=script&lang=js"
export * from "./ReclamationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports